import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Fmsagency, functionpermission ,getFmsagency} from './fms-agency.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { ToastrService } from 'ngx-toastr';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FmsAgencyService } from './fms-agency.service';
import { FmsDataService } from './fms-agencydataservice';
import { CommonApiService } from 'src/app/commonapiservice';
import { CommonHttpService } from 'src/app/common.service';
import { GeneralService } from 'src/app/service/general.service';

@Component({
  selector: 'app-fms-agency',
  templateUrl: './fms-agency.component.html',
  styleUrls: ['./fms-agency.component.scss']
})
export class FmsAgencyComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
   @Input() fromClient: string;
    @Output() emitfmsagency = new EventEmitter<number>()
  FmsForm: FormGroup;
  FmsType: string;
  public filterSettings: object;
  Deleteid: any;
  isSaveorUpdateBoolean:boolean=false;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  @ViewChild('grid') public grid: GridComponent;
  public Grid: Observable<DataStateChangeEventArgs>;
  fp: functionpermission = new functionpermission();
  statusList: any = []
  statusListItem: any=[]
  getfmsagency : getFmsagency = new getFmsagency();
  savefmsagecy : Fmsagency = new Fmsagency();
  stateList: any = [];
  
  constructor( public global: GlobalComponent,public toastrService: ToastrService,
    public http: ClientHttpService,private formBuilder: FormBuilder, public fmsagecyservice : FmsAgencyService,
  public fmsservice : FmsDataService , public commonapi : CommonApiService ,public commonhttp: CommonHttpService ,public general: GeneralService) 
  {
   
    this.FmsForm = this.formBuilder.group({
      id: ["00000000-0000-0000-0000-000000000000"],
      providerName: [' ', Validators.required],
      npi: [''],
      phoneNumber: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      address: [' ', ],
      city: [' ', ],
      state: [' ', ],
      zipCode: ["",],
      contactName: [' ', ],
      email: ["", Validators.email],
      fax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fmsFee: [Number, ],
      statusLid: ["", Validators.required], 
        });
      this.Grid = fmsservice;
   }

  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getpermission();
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
    this.getStatus();
   

  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "FMSAGENCY");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.http.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  getFmsFilter() {
  
    this.fmsservice.execute(this.getfmsagency);
    this.fmsservice.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

    }
     )
  }
   getDetails(saveBos: Fmsagency) {     
      this.savefmsagecy = JSON.parse(JSON.stringify(saveBos));
    }

  getStatus() {
    let params = new URLSearchParams();

    params.append("listCode", "STATUS");

    this.http.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.statusListItem = JSON.parse(JSON.stringify(data));
      this.statusListItem.forEach((ele) => {
        ele.Key = ele.id;
        ele.Value = ele.lovName;
      });
      this.statusList = data;
      let values = {
        id: null,
        lovName: "All",
        lovCode: "ALL",
        lovValue: "ALL",
      };
      this.statusList.push(values);
      this.getfmsagency.statusLid = this.statusList?.filter(s => s.lovName == "Active")[0].id;
      this.savefmsagecy.statusLId = this.statusListItem?.filter(s => s.Value == "Active")[0].Key;


      this.getFmsFilter();
    })
  }

    //.........................................SaveOrUpdateFms.............................................
    SaveOrUpdateFms() {
      this.isSaveorUpdateBoolean=true
      let savefmsitems : Fmsagency = JSON.parse(JSON.stringify(this.savefmsagecy))
  
      this.fmsagecyservice.SaveOrUpdateFms(savefmsitems).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.isSaveorUpdateBoolean=false
        if (data) {
          if (this.FmsType == 'CreateFmsModal') {
            this.toastrService.success('FMS Agency saved successfully!');
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
  
          }
          else if (this.FmsType == 'UpdateFmsModal') {
            this.toastrService.success('FMS Agency updated successfully!');
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
          document.getElementById('openListModal').click();
          this.FmsForm.reset();
      
          this.savefmsagecy = new Fmsagency();
          this.getFmsFilter();
        }
      }, (err: any) => {
        this.isSaveorUpdateBoolean=false
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      })
    }

      CreateorUpdateFms(data) {
        this.FmsType = data;
        if (this.FmsType == 'CreateFmsModal') {
          this.FmsForm.reset();
          this.savefmsagecy = new Fmsagency();
          this.FmsForm.controls.statusLid.setValue(
            this.statusListItem?.filter((st) => st.Value == "Active")[0].Key
          );
          this.savefmsagecy.statusLId = this.statusListItem?.filter(s => s.Value == "Active")[0].Key;
          
        }
      }

       setDeleteid(data) {
          this.Deleteid = data;
        }
        //..........................................DeleteLocation...........................................................
        DeleteFms() {
          let params = new URLSearchParams();
           params.append("Id", this.savefmsagecy.id.toString());
           let url = "api/FMSAgency/DeleteFMSAgency?";
           this.commonapi.DeleteFunctionForDeleteHttp(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
            this.toastrService.success('FMS Agency deleted successfully!');
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
            this.savefmsagecy = new Fmsagency();
            document.getElementById('closeListModal').click();
            this.getFmsFilter();
          }, (err: any) => {
            if (err) {
              this.toastrService.error(err, 'Error'), 8000;
            }
          });
      
      
        }

        clearfms(type: string) {
            this.FmsType = null;
            this.savefmsagecy = new Fmsagency();
            this.FmsForm.reset();
            if (type == "refresh") {
              this.getFmsFilter();
            }
          }


       public onActionFms(event) {
            this.getfmsagency.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
            this.getfmsagency.pageitem = this.grid.pagerModule.pagerObj.pageSize;
            if (event.name == "actionBegin" && event.requestType == "filterbeforeopen") {
              this.getfmsagency.type = event.columnType
            }
          }

          public dataChangeFms(L): void {
            let val = (L.action.requestType).toString();
            if (val != "filterchoicerequest") {
              if ((L.sorted || []).length) {
                this.getfmsagency.orderColumn = L.sorted[0].name;
                this.getfmsagency.orderType = L.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
              }
            }
            if (val == "filtering" && L.action.action != "clearFilter") {
              this.getfmsagency.value = L.action.currentFilterObject.value;
              this.getfmsagency.field = L.action.currentFilterObject.field;
              this.getfmsagency.matchCase = L.action.currentFilterObject.matchCase;
              this.getfmsagency.operator = L.action.currentFilterObject.operator;
            }
            else {
              if (val == "filtering" && L.action.action == "clearFilter") {
                this.getfmsagency.field = "providerName";
                this.getfmsagency.matchCase = false;
                this.getfmsagency.operator = "contains";
                this.getfmsagency.value = "";
                this.getfmsagency.type = "string";
              }
            }
            this.getFmsFilter();
            if (val == "paging" && L.action.name == "actionBegin") {
           
            }
          }

          showLocationColumns() {
            this.grid.columnChooserModule.openColumnChooser(200, 50);
          }
          DemographicPhoneFormat1() {
              this.savefmsagecy.fax = this.general.converPhoneGoogleLib(this.savefmsagecy.fax);
        
          }
          DemographicPhoneFormat() {
            this.savefmsagecy.phoneNumber = this.general.converPhoneGoogleLib(this.savefmsagecy.phoneNumber);
          }
          keyPress(event: any) {
            const pattern = /[0-9]/;
            let inputChar = String.fromCharCode(event.charCode);
            if (event.keyCode != 8 && !pattern.test(inputChar)) {
              event.preventDefault();
            }
          }
          numberOnly(event): boolean {
            const charCode = (event.which) ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
              return false;
            }
            return true;
          }

          Refresh() {
             
              this.getfmsagency.matchCase = false;
              this.getfmsagency.operator = "startswith";
              this.getfmsagency.value = "";
              this.getfmsagency.type = "string";
              this.getfmsagency.field = "providerName";
              this.getfmsagency.statusLid = this.statusList.filter(
                (st) => st.lovName == "Active"
              )[0].id;
              this.getfmsagency.currentpageno = 1;
    
              this.getpermission();
              this. getStatus();
            }

        public ngOnDestroy(): void {
          this.onDestroy$.next();
        }
}
